import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb } from 'semantic-ui-react';

class Breadcrumbs extends Component {
  state = { activeIndex: 0 };
  static getDerivedStateFromProps (nextProps, prevState) {
    const { activeIndex } = nextProps;
    if (activeIndex !== prevState.activeIndex) {
      return { activeIndex };
    }
    return null;
  }

  render () {
    return (
      <div className="breadcrumbs-wrapper full-width">
        <div className="wrapper">
          <Breadcrumb className="breadcrumbs">
            <div className="labels">
              <p className={ `${this.state.activeIndex >= 0 ? 'active' : ''}` }>Eligibility</p>
              <p className={ `${this.state.activeIndex >= 1 ? 'active' : ''}` }>Patient<br /> Information</p>
              <p className={ `${this.state.activeIndex >= 2 ? 'active' : ''}` }>Finish</p>
            </div>
            <div className="progress-bar">
              <div
                className={ `progress-bar-fill ${this.state.activeIndex === 0 ? 'eligibility-active' : ''}${this.state.activeIndex === 1 ? 'patient-active' : ''}${this.state.activeIndex === 2 ? 'finish-active' : ''}` }
              />
            </div>
          </Breadcrumb>
        </div>
      </div>
    );
  }
}

Breadcrumbs.propTypes = {
  activeIndex: PropTypes.number.isRequired,
};

export default Breadcrumbs;
